import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OptionDetailsComponent } from './details/option-details/option-details.component';
import { OverviewComponent } from './overview/components/overview/overview.component';
import { MobileLevelTwoComponent } from './details/mobile/level-two/container/mobile-level-two.component';
import { TvLevelTwoComponent } from './details/tv/level-two/container/tv-level-two.component';
import { InternetLevelTwoComponent } from './details/internet/level-two/container/internet-level-two.component';
import { JointOfferComponent } from './details/mobile/level-two/joint-offer/joint-offer.component';
import { PriceplanDetailsComponent } from './details/mobile/level-two/priceplan-details/priceplan-details.component';
import { DataBoostComponent } from './details/mobile/level-two/data-boost/data-boost.component';
import { TelephonyLevelTwoComponent } from './details/telephony/level-two/container/telephony-level-two/telephony-level-two.component';
import { OptionDetailsTaggingResolverService } from './guards/option-details-tagging-resolver.service';
import { PxMyMailAppComponent } from './mymail/components/mailapp/px-mymail-app.component';
import { EpressComponent } from './details/epress/epress.component';
import { DigitalisComponent } from './details/digitalis/components/container/digitalis/digitalis.component';
import { CreditAnnouncementsComponent } from './details/mobile/level-two/credit-announcements/credit-announcements.component';
import { BiptRedirectionComponent } from './bipt-redirection/bipt-redirection.component';
import { InternetUsageDetailsComponent } from './details/internet/level-two/internet-usage-details/internet-usage-details.component';
import { MyProximusAuthenticationCheckGuard } from './guards/myproximus-authentication-check.guard';
import { SmoothAccessTokenDisneyPlusGuard } from './smooth-access/guards/smooth-access-token-disney-plus.guard';
import { NspDeeplinkGuard } from './guards/nsp-deeplink.guard';
import { DefaultLoadingPageComponent } from './shared/default-loading-page/default-loading-page.component';
import { InternetSettingsPxsplusComponent } from './details/internet/level-two/internet-settings/internet-settings-pxsplus/internet-settings-pxsplus.component';
import { SimAndPukPxsplusComponent } from './details/mobile/level-two/sim-and-puk-pxsplus/sim-and-puk-pxsplus.component';
import { MobileSettingsPxsplusComponent } from './details/mobile/level-two/mobile-settings-pxsplus/mobile-settings-pxsplus.component';
import { AddNewProductComponent } from './overview/components/overview/add-new-product/add-new-product.component';
import { MobileOptionsPxsplusComponent } from './details/mobile/level-two/mobile-options-pxsplus/mobile-options-pxsplus.component';
import { InternetAvailableOptionsPxsplusComponent } from './details/internet/level-two/internet-available-options-pxsplus/internet-available-options-pxsplus.component';
import { InternetUsagePxsplusComponent } from './details/internet/level-two/internet-usage-pxsplus/internet-usage-pxsplus.component';
import { TvUsagePxsplusComponent } from './details/tv/level-two/tv-usage-pxsplus/tv-usage-pxsplus.component';
import { MobileUsagePxsplusComponent } from './details/mobile/level-two/mobile-usage-pxsplus/mobile-usage-pxsplus.component';
import { TvAvailableOptionsPxsplusComponent } from './details/tv/level-two/tv-available-options-pxsplus/tv-available-options-pxsplus.component';
import { SplitBillDetailComponent } from './details/mobile/level-two/split-bill-detail/split-bill-detail.component';
import { FlexEmergencyManagePxsplusComponent } from './details/internet/level-two/flex-emergency/flex-emergency-manage-pxsplus/flex-emergency-manage-pxsplus.component';
import { FlexEmergencyEntryPxsplusComponent } from './details/internet/level-two/flex-emergency/flex-emergency-entry-pxsplus/flex-emergency-entry-pxsplus.component';
import { FlexEmergencyActivationPxsplusComponent } from './details/internet/level-two/flex-emergency/flex-emergency-activation-pxsplus/flex-emergency-activation-pxsplus.component';
import { FlexEmergencyConfirmationPxsplusComponent } from './details/internet/level-two/flex-emergency/flex-emergency-confirmation-pxsplus/flex-emergency-confirmation-pxsplus.component';
import { SimComponent } from './sim/sim.component';
import { SimTransferComponent } from './sim/sim-transfer/sim-transfer.component';
import { SimReplaceComponent } from './sim/sim-replace/sim-replace.component';
import { SimPhysicalComponent } from './sim/sim-replace/sim-physical/sim-physical.component';
import { ModemChoiceComponent } from './modem-choice/modem-choice.component';
import { UserAccessManagementComponent } from './details/user-access/user-access-management/user-access-management.component';
import { IntentActivatedGuard } from "./guards/intent-activated.guard";
import { GetJwtRedirectComponent } from "./get-jwt-redirect/get-jwt-redirect.component";

const routes: Routes = [
  {
    path: 'overview',
    component: OverviewComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts overview',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'overview',
          },
        },
      },
    },
  },
  {
    path: 'add-product',
    component: AddNewProductComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts add a product',
          id: 'myproducts add a product',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'add a product',
          },
        },
      },
    },
  },
  {
    path: 'add-product/:category',
    component: AddNewProductComponent,
    canActivate: [MyProximusAuthenticationCheckGuard, IntentActivatedGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts add a product',
          id: 'myproducts add a product',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'add a product',
          },
        },
      },
    },
  },
  {
    path: 'get-jwt',
    component: GetJwtRedirectComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts get jwt',
          id: 'myproducts get jwt',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'get jwt',
          }
        }
      }
    }
  },
  {
    path: 'details/mobile',
    component: MobileLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options',
          id: 'myproducts mobile options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/mobile',
    component: MobileLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options',
          id: 'myproducts mobile options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options',
          },
        },
      },
    },
  },
  {
    path: 'user-access-management',
    component: UserAccessManagementComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts user manager',
          id: 'myproducts user manager',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'user manager',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/user-access-management',
    component: UserAccessManagementComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts user manager deeplink ',
          id: 'myproducts user manager deeplink',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'user manager',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/joint-offer',
    component: JointOfferComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options joint offer',
          id: 'myproducts mobile options joint offer',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options joint offer',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/mobile/joint-offer/:token',
    component: JointOfferComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options joint offer deeplink',
          id: 'myproducts mobile options joint offer deeplink',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options joint offer',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/pricing-plan',
    component: PriceplanDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options pricing plan',
          id: 'myproducts mobile options pricing plan',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options pricing plan',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/mobile-price-plan-swap/:token',
    component: PriceplanDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options pricing plan swap with deeplink',
          id: 'myproducts mobile options pricing plan swap with deeplink',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options pricing plan swap with deeplink',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/data-boost',
    component: DataBoostComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile options data full speed',
          id: 'myproducts mobile options data full speed',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options data full speed',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/credit-settings',
    component: CreditAnnouncementsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts mobile credit announcements management',
          id: 'myproducts mobile credit announcements management',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile options credit announcements management',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/split-bill',
    component: SplitBillDetailComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'mobile splitbill details',
          id: 'mobile splitbill details',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mobile split-bill details',
          },
        },
      },
    },
  },
  {
    path: 'details/mobile/:msisdn/sim',
    component: SimComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: { simType: 'sim' },
  },
  {
    path: 'details/mobile/:msisdn/sim/replace',
    component: SimReplaceComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/mobile/:msisdn/sim/replace/physical',
    component: SimPhysicalComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/mobile/:msisdn/esim',
    component: SimComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: { simType: 'esim' },
  },
  {
    path: 'details/mobile/:msisdn/esim/transfer',
    component: SimTransferComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/mobile/:msisdn/esim/replace',
    component: SimReplaceComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/mobile/:msisdn/esim/replace/physical',
    component: SimPhysicalComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/tv',
    component: TvLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts tv options',
          id: 'myproducts tv options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'tv options',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/tv',
    component: TvLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts tv options',
          id: 'myproducts tv options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'tv options',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/tv/:token',
    component: TvLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts tv options',
          id: 'myproducts tv options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'tv options',
          },
        },
      },
    },
  },
  {
    path: 'details/internet',
    component: InternetLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts internet options',
          id: 'myproducts internet options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'internet options',
          },
        },
      },
    },
  },
  {
    path: 'details/internet/usage',
    component: InternetUsageDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts internet usage details',
          id: 'myproducts internet usage details',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'internet usage details',
          },
        },
      },
    },
  },
  {
    path: 'details/internet/:circuitId/modem-choice',
    component: ModemChoiceComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
  },
  {
    path: 'details/telephony',
    component: TelephonyLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts fixed telephony options',
          id: 'myproducts fixed telephony options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'fixed telephony options',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/telephony',
    component: TelephonyLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts fixed telephony options',
          id: 'myproducts fixed telephony options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'fixed telephony options',
          },
        },
      },
    },
  },
  {
    path: 'details/mail',
    component: PxMyMailAppComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproximus mail',
          id: 'myproximus mail',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'mail',
          },
        },
      },
    },
  },
  {
    path: 'details/epress',
    component: EpressComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts epress options',
          id: 'myproducts epress options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'epress options',
          },
        },
      },
    },
  },
  {
    path: 'details/digitalis',
    component: DigitalisComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts digitalis options',
          id: 'myproducts digitalis options',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'digitalis options',
          },
        },
      },
    },
  },
  {
    path: 'details/option/:mpcUuid/:productType',
    component: OptionDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    resolve: {
      categoryL3: OptionDetailsTaggingResolverService,
    },
    data: {
      analytics: {
        page: {
          name: '', // injected dynamically by the resolver
          id: '', // injected dynamically by the resolver
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: '', // injected dynamically by the resolver
          },
        },
      },
    },
  },
  {
    path: 'DisneyPlusBCGToken',
    component: OptionDetailsComponent,
    canActivate: [SmoothAccessTokenDisneyPlusGuard],
    data: {
      analytics: {
        page: {
          name: '', // injected dynamically by the resolver
          id: '', // injected dynamically by the resolver
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: '', // injected dynamically by the resolver
          },
        },
      },
    },
  },
  {
    path: 'option/:deepLinkMpcUuid',
    component: OptionDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts deeplink options ordering',
          id: 'myproducts deeplink options ordering',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'deeplink options ordering',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/details/internet',
    component: InternetLevelTwoComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts deeplink internet details',
          id: 'myproducts deeplink internet details',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'internet options',
          },
        },
      },
    },
  },
  {
    path: 'deeplink/nsp',
    canActivate: [MyProximusAuthenticationCheckGuard, NspDeeplinkGuard],
    component: DefaultLoadingPageComponent,
    children: [
      {
        path: '**',
        redirectTo: '/deeplink/nsp',
      },
    ],
  },
  {
    path: 'deeplink/NSP',
    redirectTo: 'deeplink/nsp',
    pathMatch: 'full',
  },
  {
    path: 'overview/:serviceId',
    component: OverviewComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts overview',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'overview',
          },
        },
      },
    },
  },
  {
    path: 'tariffSimulator',
    component: BiptRedirectionComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts best tariff',
          id: 'myproducts best tariff',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'best tariff',
          },
        },
      },
    },
  },
  {
    path: 'pxsplus',
    canActivate: [MyProximusAuthenticationCheckGuard],
    children: [
      {
        path: 'internet-settings',
        component: InternetSettingsPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ internet options details',
              id: 'PXS+ internet options details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'internet options details',
              },
            },
          },
        },
      },
      {
        path: 'tv-usage',
        component: TvUsagePxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ tv usage details',
              id: 'PXS+ tv usage details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'tv usage details',
              },
            },
          },
        },
      },
      {
        path: 'tv-options',
        component: TvAvailableOptionsPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ tv available options',
              id: 'PXS+ tv available options',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'tv available options',
              },
            },
          },
        },
      },
      {
        path: 'sim-info',
        component: SimAndPukPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ sim info details',
              id: 'PXS+ sim info details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'sim info details',
              },
            },
          },
        },
      },
      {
        path: 'mobile-usage',
        component: MobileUsagePxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ mobile usage details',
              id: 'PXS+ mobile usage details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'mobile usage details',
              },
            },
          },
        },
      },
      {
        path: 'mobile-settings',
        component: MobileSettingsPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ mobile settings details',
              id: 'PXS+ mobile settings details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'mobile settings details',
              },
            },
          },
        },
      },
      {
        path: 'mobile-options',
        component: MobileOptionsPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ mobile options details',
              id: 'PXS+ mobile options details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'mobile options details',
              },
            },
          },
        },
      },
      {
        path: 'add-product',
        component: AddNewProductComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ add new product',
              id: 'PXS+ add new product',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'add a new product',
              },
            },
          },
        },
      },
      {
        path: 'internet-options',
        component: InternetAvailableOptionsPxsplusComponent,
        canActivate: [MyProximusAuthenticationCheckGuard],
        data: {
          analytics: {
            page: {
              name: 'PXS+ internet options details',
              id: 'PXS+ internet options details',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'internet options details',
              },
            },
          },
        },
      },
      {
        path: 'internet-usage',
        component: InternetUsagePxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'PXS+ internet usage',
              id: 'PXS+ internet usage',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'internet usage detail',
              },
            },
          },
        },
      },
      {
        path: 'flex-emergency-manage',
        component: FlexEmergencyManagePxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'flex-emergency-manage',
              id: 'flex-emergency-manage',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'flex-emergency-manage',
              },
            },
          },
        },
      },
      {
        path: 'flex-emergency-entry',
        component: FlexEmergencyEntryPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'flex-emergency-entry',
              id: 'flex-emergency-entry',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'flex-emergency-entry',
              },
            },
          },
        },
      },
      {
        path: 'flex-emergency-activation',
        component: FlexEmergencyActivationPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'flex-emergency-activation',
              id: 'flex-emergency-activation',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'flex-emergency-activation',
              },
            },
          },
        },
      },
      {
        path: 'flex-emergency-confirmation',
        component: FlexEmergencyConfirmationPxsplusComponent,
        data: {
          analytics: {
            page: {
              name: 'flex-emergency-confirmation',
              id: 'flex-emergency-confirmation',
              category: {
                l1: 'myproximus',
                l2: 'myproducts',
                l3: 'flex-emergency-confirmation',
              },
            },
          },
        },
      },
    ],
  },
  {
    path: 'home',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: '.html', // default path when clicking on Magnolia TLC: /My-Products-ng__.html
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/overview',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
